module.exports = __webpack_public_path__ + "img/tarot-major-arcana-10.7a4b3c36.png";